import { MaskitoOptions, maskitoTransform } from '@maskito/core';

import { PhoneMaskProps } from './types';

// Самый длинный номер телефона, который может быть в мире https://nda.ya.ru/t/ARwoCdaS73h5fe
const MAX_PHONE_DIGITS_COUNT = 15;
const DIGIT_REGEXP = /\d/;
export const getPhoneMask = (phoneMaskProps: PhoneMaskProps = {}): MaskitoOptions => {
    const { allowAnyRegion = false } = phoneMaskProps;

    return {
        mask: allowAnyRegion
            ? elementState => {
                  const digitsCount = elementState.value.replace(/[^\d\*]/, '').length;

                  const limitedByMaxDigitsCount = Math.min(digitsCount, MAX_PHONE_DIGITS_COUNT);

                  return ['+', ...new Array<RegExp>(limitedByMaxDigitsCount || 1).fill(DIGIT_REGEXP)];
              }
            : [
                  '+',
                  '7',
                  ' ',
                  '(',
                  DIGIT_REGEXP,
                  DIGIT_REGEXP,
                  DIGIT_REGEXP,
                  ')',
                  ' ',
                  DIGIT_REGEXP,
                  DIGIT_REGEXP,
                  DIGIT_REGEXP,
                  '-',
                  DIGIT_REGEXP,
                  DIGIT_REGEXP,
                  '-',
                  DIGIT_REGEXP,
                  DIGIT_REGEXP,
              ],
    };
};

export const transformPhoneToMasked = (phone: string, phoneMaskProps: PhoneMaskProps = {}) => {
    const mask = getPhoneMask(phoneMaskProps);

    return maskitoTransform(phone, mask);
};
